var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiReco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_542_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 12.5V11.25H11.8751V6.875H11.2501V5.625H13.7501V6.875H13.1251V11.25H13.7501V12.5H11.2501ZM9.06258 12.5H10.3126L8.12508 5.625H6.25008L4.06445 12.5H5.31445L5.69008 11.25H8.67633L9.06258 12.5ZM6.06633 10L7.08383 6.61812L7.24383 6.61625L8.29008 10H6.06633ZM16.3857 13.125L15.2688 15.3881L12.7713 15.7506L14.5788 17.5131L14.152 20L16.3857 18.8256L18.6195 20L18.1926 17.5125L20.0001 15.7512L17.5026 15.3881L16.3857 13.125Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 18.75H0V0H18.75V10.625H17.5V1.25H1.25V17.5H10.625V18.75Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiReco);
export default __webpack_public_path__ + "static/media/ai_reco.c777fe731d883b6a0f2a79b38e370c8f.svg";
export { ForwardRef as ReactComponent };